import { cn } from "@/lib/cn";

/**
 * Restrained inline score chip. Use sparingly — at most one or two per card.
 * Color modulates by value so trend acceleration is visible at a glance.
 */
export function Score({
  label,
  value,
  className,
}: {
  label: string;
  value: number; // 0..1
  className?: string;
}) {
  const v = Math.max(0, Math.min(1, value));
  const tone =
    v >= 0.75
      ? "text-gold-glow border-gold/40"
      : v >= 0.5
        ? "text-fog border-veil"
        : "text-whisper border-veil/60";
  return (
    <div
      className={cn(
        "inline-flex items-center gap-2 px-2.5 py-1 rounded-full border text-[11px] tabular-nums",
        tone,
        className,
      )}
    >
      <span className="text-muted uppercase tracking-wider">{label}</span>
      <span className="font-mono">{(v * 100).toFixed(0)}</span>
    </div>
  );
}
